import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-bespoke-subtype-form',
    templateUrl: './bespoke-subtype-form.component.html',
    styleUrls: ['./bespoke-subtype-form.component.scss']
})
export class BespokeSubtypeFormComponent implements OnInit {
    @Input() product;
    @Input() subTypes;
    @Output() recalculate = new EventEmitter();
    @Output() setSubStep = new EventEmitter();
    @Output() clearSubStep = new EventEmitter();


    finishParams;

    constructor() {
    }

    ngOnInit(): void {
        this.subTypes.forEach(st => {
            // if (st.id === 75) {
            //     this.toggleSubType(st);
            // }
        });
    }

    subTypeSelected(id) {
        for (let i = 0; i < this.product.subTypes.length; i++) {

            if (this.product.subTypes[i].id === id) {
                return true;
            }
        }
        return false;
    }

    triggerFinishSelection(options, v1, v2) {
        this.finishParams = {
            options,
            type: v1,
            side: v2
        };
    }

    updateFinishSelected(e) {
        if (e.update) {
            if (this.product.type.id === 'coping') {
                this.product[this.finishParams.type]['front'] = e.finishSelected;
                this.product[this.finishParams.type]['back'] = e.finishSelected;

            } else if (this.product.type.id === 'piercaps') {
                this.product[this.finishParams.type]['front'] = e.finishSelected;
                this.product[this.finishParams.type]['back'] = e.finishSelected;

                this.product[this.finishParams.type]['left'] = e.finishSelected;
                this.product[this.finishParams.type]['right'] = e.finishSelected;

            } else if (this.product.type.id === 'steps') {
                if (!e.all) {
                    this.product[this.finishParams.type][this.finishParams.side] = e.finishSelected;

                } else {
                    this.product[this.finishParams.type]['front'] = e.finishSelected;
                    this.product[this.finishParams.type]['back'] = '';
                    this.product[this.finishParams.type]['left'] = e.finishSelected;
                    this.product[this.finishParams.type]['right'] = e.finishSelected;
                }
            } else {
                if (!e.all) {
                    this.product[this.finishParams.type][this.finishParams.side] = e.finishSelected;

                } else {
                    this.product[this.finishParams.type]['front'] = e.finishSelected;
                    this.product[this.finishParams.type]['back'] = e.finishSelected;

                    this.product[this.finishParams.type]['left'] = e.finishSelected;
                    this.product[this.finishParams.type]['right'] = e.finishSelected;
                }
            }
            this.finishParams = undefined;
            this.calcBespokeCost();
        } else {
            this.finishParams = undefined;
        }

    }

    toggleSubType(subType) {
        if (this.subTypeSelected(subType.id)) {
            for (let i = 0; i < this.product.subTypes.length; i++) {
                if (this.product.subTypes[i].id === subType.id) {
                    this.product.subTypes.splice(i, 1);
                }
            }
        } else {
            this.product.subTypes.push(subType);
        }
    }

    removeProductValues(type) {
        this.product[type] = undefined;
    }

    setProductValues(type, value) {
        this.product[type] = value;
        this.calcBespokeCost();
    }

    calcBespokeCost() {
        this.recalculate.emit();
    }

    triggerSetSubStep(step) {
        this.setSubStep.emit(step);
    }

    triggerClearSubStep() {
        this.clearSubStep.emit();
    }

}
